export default __webpack_public_path__ + "static/media/idocsignSidebar.ed33fa23.png";